export default __webpack_public_path__ + "static/cta-dont-9de283d3a5a1646c35a0e3a6fe9016c3.png";